interface String {
    toInt(): number;
    toJson(): any;
}

String.prototype.toInt = function () {
    return this ? parseInt(this, 10) : null;
};

String.prototype.toJson = function () {
    return JSON.parse(this);
};
